import React from 'react'
import PlanCard from '../PlanCard'

type PagarProps = {
  months: string
  price: string
  total: string
  type: string
}

type Props = {
  price: string
  total: string
  loading: boolean
  Pagar: ({ months, price, total, type }: PagarProps) => void
}

export const PaymentYear = (props: Props) => {
  const { price, total, loading, Pagar } = props
  return (
    <>
      <PlanCard
        title="Super desconto"
        price={price}
        cents={price}
        caption="Pagamento anual"
        description={[
          'Mega promoção com 10% de',
          'desconto na compra de 1 ano!',
        ]}
        benefits={['Desconto imperdível', 'Garanta 1 ano de acesso']}
        value={`O valor de R$ ${Number(total).toLocaleString('pt-BR')}`}
        cardColor="#3EB9F2"
        buttonText={
          <div className="w-full h-full ">
            {loading ? (
              <div className="flex justify-center w-full h-full">
                <button
                  style={{ color: '#3EB9F2' }}
                  className="w-5/6 py-2 mt-2 font-semibold text-center bg-white rounded"
                >
                  Aguarde...
                </button>
              </div>
            ) : (
              <div className="flex justify-center w-full h-full ">
                <button
                  onClick={() =>
                    Pagar({
                      months: '12',
                      price: price,
                      total: total,
                      type: 'Pagamento de um ano de acesso ao site igreja nas nuvens',
                    })
                  }
                  className="w-5/6 py-2 mt-2 font-semibold text-center bg-white border border-transparent rounded"
                  style={{ color: '#3EB9F2' }}
                >
                  Aproveitar a promoção
                </button>
              </div>
            )}
          </div>
        }
      />
    </>
  )
}
